import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

const lineVariants = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.05, ease, delay: i * 0.09 } }),
};

export const MaskLines = ({ lines, className = "", lineClassName = "", onLoad = false, delay = 0 }) => {
  const trigger = onLoad
    ? { initial: "hidden", animate: "show" }
    : { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <motion.span {...trigger} className={`block ${className}`}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span custom={i + delay} variants={lineVariants} className={`block will-change-transform ${lineClassName}`}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const FadeUp = ({ children, className = "", delay = 0, as = "div" }) => {
  const C = motion[as];
  return (
    <C
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease, delay }}
      className={className}
    >
      {children}
    </C>
  );
};
